"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/Controllers/SimpleTextAreaController.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _reacthookform = require('react-hook-form');

var _SimpleTextArea = require('web/components/Form/SimpleTextArea'); var _SimpleTextArea2 = _interopRequireDefault(_SimpleTextArea);






const SimpleTextAreaController = ({
  name,
  control,
  ...props
}) => (
  _react2.default.createElement(_reacthookform.Controller, {
    name: name,
    control: control,
    render: ({ field }) => (
      _react2.default.createElement(_SimpleTextArea2.default, {
        value: field.value ,
        onChange: field.onChange,
        ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      )
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
  )
  )

exports. default = SimpleTextAreaController
